<script setup lang="ts">
import { onMounted, ref } from "vue";
import type { ProductListItem } from "@wjbk/workbench-contracts";
import { api } from "../api";
const rows = ref<ProductListItem[]>([]);
const error = ref("");
onMounted(async () => { try { rows.value = await api.products(); } catch (e) { error.value = (e as Error).message; } });
</script>

<template>
  <div class="panel">
    <div class="toolbar"><div><h2>统一商品台账</h2><span class="muted">外部系统商品 ID 通过映射表关联，不互相覆盖</span></div><el-button type="primary" disabled>新建商品（下一批）</el-button></div>
    <div v-if="error" class="error">{{ error }}</div>
    <el-table v-else :data="rows" empty-text="尚未导入商品主数据">
      <el-table-column prop="code" label="商品编码" width="170" />
      <el-table-column prop="name" label="商品名称" min-width="240" />
      <el-table-column prop="lifecycleStatus" label="生命周期" width="130" />
      <el-table-column prop="ownerName" label="负责人" width="130" />
      <el-table-column prop="updatedAt" label="更新时间" width="190" />
      <el-table-column label="操作" width="90"><template #default="scope"><RouterLink :to="`/products/${scope.row.id}`">查看</RouterLink></template></el-table-column>
    </el-table>
  </div>
</template>
